import { observer } from "mobx-react-lite";

import { usePageStore } from "../service-detail-page.lib";
import { KitsTabContent } from "./kits-tab-content";
import { RoadsTabContent } from "./roads-tab-content";
import { ServiceDetailHeader } from "./service-detail-header";
import { ServiceDetailTabs } from "./service-detail-tabs";
import { VersionsTabContent } from "./versions-tab-content";

/** Контент карточки услуги: шапка, табы и активная вкладка (по активному табу в сторе). */
export const ServiceDetailContent = observer(() => {
  const store = usePageStore()!;

  return (
    <>
      <ServiceDetailHeader />
      <ServiceDetailTabs />
      {store.activeTab === "versions" ? <VersionsTabContent /> : null}
      {store.activeTab === "kits" ? <KitsTabContent /> : null}
      {store.activeTab === "roads" ? <RoadsTabContent /> : null}
    </>
  );
});
